import { render, staticRenderFns } from "./ComponentIcons.vue?vue&type=template&id=be1d4bce&scoped=true&"
import script from "./ComponentIcons.vue?vue&type=script&lang=js&"
export * from "./ComponentIcons.vue?vue&type=script&lang=js&"
import style0 from "./ComponentIcons.vue?vue&type=style&index=0&id=be1d4bce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1d4bce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
